<template>
  <div class="container">
    <section class="newsletter-box">
      <img
        :src="imgBack"
        class="img-back"
        alt="Banner Newsletter"
        loading="lazy"
      />
      <div class="newsletter-box__body">
        <p
          class="newsletter-box__description"
          v-text="translate.newsletterMessage"
        />
        <div class="newsletter-box__textbox">
          <form @submit.prevent="addToNewsletter">
            <input
              type="email"
              name="email"
              :placeholder="translate.inputEmail"
              required
              v-model="email"
              @keyup.enter="addToNewsletter"
            />
            <button type="submit" aria-label="Newsletter">
              <i class="icon-arrow-right"></i>
            </button>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>
<script lang="ts">
import validationErrors from "@/shared/mixins/validationErrors";
export default defineComponent({
  mixins: [validationErrors],
});
</script>
<script lang="ts" setup>
import translateMain from "@/tradutors/menu";
import api from "@/api";

const emits = defineEmits(["showModalMessages"]);
const route = useRoute();
const translate = computed(() =>
  route.params.language == "pt-br" ? translateMain.portugues : translateMain.ingles
);
const email = ref("");
const imgBack = ref(
  "https://api.belladasemana.com.br/assets/img/home-bg-newsletter.webp"
);

function addToNewsletter() {
  api
    .post("v1/newsletter/storeNewsletterApi?email=" + email.value)
    .then(({ data }) => {
      emits("showModalMessages", {
        message: {
          show: true,
          title: "",
          textBoby: data.return,
          textButton: route.params.language == "pt-br" ? "Fechar" : "Close",
        },
      });
    });
}
</script>

<style scoped>
.img-back {
  position: absolute;
}

.newsletter-box {
  margin-bottom: 50px;
  background: unset;
}

.newsletter-box__textbox input {
  font-size: 17px;
  position: relative;
  width: 100%;
  height: 100%;
  text-align: start;
  padding: 17px 15px;
  color: #fff;
  border: none;
  background: none;
  outline: none;
}

@media screen and (max-width: 769px) {
  .newsletter-box__textbox input {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: start;
    padding: 17px 15px;
    color: #fff;
    border: none;
    background: none;
    outline: none;
    font-family: "Roboto-Regular";
    font-size: 13px;
    letter-spacing: 0;
  }
  .newsletter-box {
    top: 25px;
    padding: 30px 0px;
    margin: 0;
  }

  .newsletter-box__description {
    color: #ffffff;
    font-family: "Exo-2";
    font-size: 24px;
    letter-spacing: 0;
    line-height: 29px;
    text-align: center;
  }
}
@media screen and (max-width: 992px) {
  .img-back {
    display: none;
  }
  .newsletter-box {
    background: #000;
  }
}
</style>
